import {
  defaultFont,
  dangerColor,
  whiteColor,
} from "assets/jss/material-dashboard-pro-react.js";

import customDropdownStyle from "assets/jss/material-dashboard-pro-react/components/customDropdownStyle.js";

const adminNavbarLinksStyle = (theme) => ({
  ...customDropdownStyle(theme),
  search: {
    margin: "0",
    paddingTop: "7px",
    paddingBottom: "7px",
    [theme.breakpoints.down("sm")]: {
      margin: "10px 15px",
      float: "none !important",
      paddingTop: "1px",
      paddingBottom: "1px",
      padding: "10px 15px",
      width: "auto",
    },
  },
  searchInput: {
    paddingTop: "2px",
  },
  searchRTL: {
    [theme.breakpoints.down("sm")]: {
      marginRight: "18px !important",
    },
    [theme.breakpoints.up("md")]: {
      marginLeft: "12px",
    },
  },
  roleLabel : {
    fontWeight: "400",
    textTransform: "capitalize"
  },
  linkText: {
    zIndex: "4",
    ...defaultFont,
    fontSize: "14px",
    margin: "0!important",
    fontWeight: "600",
    textTransform: "none",
  },
  buttonLink: {
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      margin: "5px 15px 0",
      width: "auto",
      height: "auto",
      "& svg": {
        width: "30px",
        height: "24px",
        marginRight: "19px",
        marginLeft: "3px",
      },
      "& .fab,& .fas,& .far,& .fal,& .material-icons": {
        width: "30px",
        fontSize: "24px",
        lineHeight: "30px",
        marginRight: "19px",
        marginLeft: "3px",
      },
    },
  },
  searchButton: {
    [theme.breakpoints.down("sm")]: {
      top: "-50px !important",
      marginRight: "38px",
      float: "right",
    },
  },
  top: {
    zIndex: "4",
  },
  searchIcon: {
    width: "17px",
    zIndex: "4",
  },
  links: {
    width: "20px",
    height: "20px",
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      display: "block",
      width: "30px",
      height: "30px",
      color: "inherit",
      opacity: "0.8",
      marginRight: "16px",
      marginLeft: "-5px",
    },
  },
  notifications: {
    zIndex: "4",
    [theme.breakpoints.up("md")]: {
      position: "absolute",
      top: "5px",
      border: "1px solid " + whiteColor,
      right: "5px",
      fontSize: "9px",
      background: dangerColor[0],
      color: whiteColor,
      minWidth: "16px",
      height: "16px",
      borderRadius: "10px",
      textAlign: "center",
      lineHeight: "14px",
      verticalAlign: "middle",
      display: "block",
    },
    [theme.breakpoints.down("sm")]: {
      ...defaultFont,
      fontSize: "14px",
      marginRight: "8px",
    },
  },
  wrapperRTL: {
    [theme.breakpoints.up("md")]: {
      paddingLeft: "16px",
    },
  },
  buttonLinkRTL: {
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
      justifyContent: "flex-end",
      width: "-webkit-fill-available",
      margin: "10px 15px 0",
      padding: "10px 15px",
      display: "block",
      position: "relative",
    },
  },
  labelRTL: {
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row-reverse",
      justifyContent: "initial",
      display: "flex",
    },
  },
  linksRTL: {
    [theme.breakpoints.down("sm")]: {
      marginRight: "-5px !important",
      marginLeft: "16px !important",
    },
  },
  managerClasses: {
    [theme.breakpoints.up("md")]: {
      display: "inline-block",
    },
  },
  headerLinksSvg: {
    width: "20px !important",
    height: "20px !important",
  },
  navContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    gap: "12px",
  },
  verticalDivider: {
    width: "1px",
    height: "26px",
    backgroundColor: "rgba(0, 0, 0, 0.12)",
    flexShrink: 0,
  },
  orgChip: {
    ...defaultFont,
    display: "inline-flex",
    alignItems: "center",
    maxWidth: "320px",
    fontSize: "12px",
    fontWeight: 600,
    color: "#3C4858",
    backgroundColor: "rgba(0, 0, 0, 0.04)",
    borderRadius: "16px",
    padding: "5px 12px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  versionBadge: {
    ...defaultFont,
    display: "inline-flex",
    alignItems: "center",
    fontSize: "11px",
    fontWeight: 700,
    letterSpacing: "0.3px",
    color: "#2E7D32",
    backgroundColor: "rgba(46, 125, 50, 0.10)",
    border: "1px solid rgba(46, 125, 50, 0.25)",
    borderRadius: "12px",
    padding: "3px 9px",
    cursor: "default",
    userSelect: "none",
  },
  viewToggleWrap: {
    display: "flex",
    alignItems: "center",
    margin: "0 !important",
  },
  viewToggleLabel: {
    ...defaultFont,
    fontSize: "12px",
    fontWeight: 600,
    color: "#3C4858",
    whiteSpace: "nowrap",
  },
  userBlock: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    lineHeight: 1.2,
  },
  userNameText: {
    ...defaultFont,
    fontSize: "14px",
    fontWeight: 700,
    color: "#3C4858",
    margin: "0 !important",
    whiteSpace: "nowrap",
  },
  userRoleText: {
    ...defaultFont,
    fontSize: "11px",
    fontWeight: 500,
    color: "#8492A6",
    textTransform: "capitalize",
    margin: "0 !important",
    whiteSpace: "nowrap",
  },
  avatarButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "38px",
    height: "38px",
    minWidth: "38px",
    padding: "0",
    borderRadius: "50%",
    backgroundColor: dangerColor[0],
    color: whiteColor,
    border: "none",
    outline: "none",
    cursor: "pointer",
    boxShadow: "0 2px 6px rgba(231, 63, 59, 0.40)",
    transition: "all 150ms ease",
    "&:hover,&:focus": {
      backgroundColor: "#d12f2b",
      boxShadow: "0 4px 10px rgba(231, 63, 59, 0.50)",
    },
  },
  avatarIcon: {
    width: "20px !important",
    height: "20px !important",
    color: whiteColor,
  },
});

export default adminNavbarLinksStyle;
